import { Suspense, lazy } from 'react';
import { BrowserRouter, HashRouter, Navigate, Routes, Route } from 'react-router-dom';
import AuthLayout from './components/layout-v2/AuthLayout';
import AppLayout from './components/layout-v2/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';
const LoginPage = lazy(() => import('./pages-v2/LoginPage'));
const ForgotPasswordPage = lazy(() => import('./pages-v2/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('./pages-v2/ResetPasswordPage'));
const AcceptInvitePage = lazy(() => import('./pages-v2/AcceptInvitePage'));
const DashboardPage = lazy(() => import('./pages-v2/DashboardPage'));
const TicketsPage = lazy(() => import('./pages-v2/TicketsPage'));
const CreateTicketPage = lazy(() => import('./pages-v2/CreateTicketPage'));
const TicketDetailPage = lazy(() => import('./pages-v2/TicketDetailPage'));
const ProfilePage = lazy(() => import('./pages-v2/ProfilePage'));
const NotFoundPage = lazy(() => import('./pages-v2/NotFoundPage'));
import { isEmbedded } from './lib/embed';

// Use HashRouter when embedded in iframe (works without server-side routing)
const Router = isEmbedded() ? HashRouter : BrowserRouter;
const EMBEDDED = isEmbedded();

function RouteFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center" style={{ background: 'var(--base)' }}>
      <div className="spinner" style={{ width: 28, height: 28, borderWidth: 3 }} />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          {/* Public auth routes */}
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Route>

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={EMBEDDED ? <Navigate to="/tickets" replace /> : <DashboardPage />} />
              <Route path="/tickets" element={<TicketsPage />} />
              <Route path="/tickets/new" element={<CreateTicketPage />} />
              <Route path="/tickets/:id" element={<TicketDetailPage />} />
              <Route path="/profile" element={EMBEDDED ? <Navigate to="/tickets" replace /> : <ProfilePage />} />
            </Route>
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}
